export const dateShort = (timestamp = '') =>
  new Date(timestamp).toUTCString()?.split(' ').slice(1, 4).join(' ');
